import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  switch(event) {
    // Let Turbo handle navigation — server renders each tab as a full page
  }
}
